<nz-layout>
  <nz-content>
    <div class="authContainer" [ngClass]="{
        'cui__layout__squaredBorders': isSquaredBorders,
        'cui__layout__cardsShadow': isCardShadow,
        'cui__layout__borderless': isBorderless,
        'white': authPagesColor === 'white',
        'gray': authPagesColor === 'gray'

      }">
      <div class="topbar" [ngClass]="{
        'topbarGray': isGrayTopbar
      }">
        <div class="logoContainer">
          <div class="logo">
            <ng-container *ngIf="false">
              <img src="assets/images/icons/ico_logo.svg" class="mr-2" alt="{{ logo }}" />
              <div class="name">{{ logo }}</div>
            </ng-container>
          </div>
        </div>
      </div>

      <video autoplay muted loop id="login-video-bg">
        <source src="../../../assets/video/background.mp4" type="video/mp4">
      </video>

      <div class="containerInner">
<!--        <div -->
<!--          [@slideFadeinUp]="routeAnimation(outlet, 'slideFadeinUp')"-->
<!--          [@slideFadeinRight]="routeAnimation(outlet, 'slideFadeinRight')"-->
<!--          [@zoomFadein]="routeAnimation(outlet, 'zoomFadein')" -->
<!--          [@fadein]="routeAnimation(outlet, 'fadein')">-->
          <router-outlet #outlet="outlet"></router-outlet>
<!--        </div>-->
      </div>
      <div class="mt-auto pb-5 pt-5">
        <div class="text-center">
          Copyright © {{ year }} SPAS
        </div>
      </div>
    </div>
  </nz-content>
</nz-layout>
